import { Injectable } from '@angular/core';
import { FormExtractorService } from 'src/app/modules/shared/services/form-extractor.service';
import { RadioCheckBoxEnum } from '../../../../common/radio.checkbox.enums';
import { Conditions } from '../../models/Conditions';
import { TypeLangue } from '../../models/TypeLangue';

@Injectable({
  providedIn: 'root'
})
export class ConditionsService {

  constructor() {
  }

  getConditions(controls: any, formExtractorService: FormExtractorService) {

    const conditions = new Conditions();
    conditions.autresConditionsNon =
      this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Conditions_SepAtt_autresConditionsNon'));
    conditions.autresConditionsOui =
      this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Conditions_SepAtt_autresConditionsOui'));
    conditions.euro = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Conditions_SepAtt_euro')) ? RadioCheckBoxEnum.emptyValue : null;
    conditions.formeJuridique = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Conditions_SepAtt_formeJuridique'));
    conditions.garanties = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Conditions_SepAtt_garanties'));
    conditions.langue = new TypeLangue();
    conditions.langue.langAutre = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Conditions_SepSep_TypeLangue_SepAtt_langAutre'));
    conditions.langue.langEC = controls.get('_SepSep_Initial_SepSep_Conditions_SepSep_TypeLangue_SepAtt_langEC');
    conditions.langueFR = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Conditions_SepAtt_langueFR')) ? RadioCheckBoxEnum.emptyValue : null;
    conditions.modFinancement = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Conditions_SepAtt_modFinancement'));
    return conditions;
  }

  private sanitizeString(value: any): string | null {
    if (typeof value !== 'string') {
      return value;
    }
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
  }
}
